// extracted by mini-css-extract-plugin
module.exports = {"note":"styles_note__BLBva","deleting_note":"styles_deleting_note__JJpYg","note_mast":"styles_note_mast__NypE0","action":"styles_action__QUAeq"};